module.exports = __webpack_public_path__ + "static/media/plane.1e059e89.svg";